/* Cursor-following label magnifier for the shared product gallery. */
(() => {
  let cleanup;
  function init() {
    cleanup?.();
    const stage = document.getElementById('product-stage');
    const source = document.getElementById('hero-image');
    if (!stage || !source) return;
    const controller = new AbortController();
    const on = (node, type, handler, options = {}) => node.addEventListener(type, handler, {...options, signal: controller.signal});
    const pointer = matchMedia('(any-hover: hover) and (any-pointer: fine)');
    const lens = document.createElement('div');
    lens.className = 'ps-magnifier';
    lens.hidden = true;
    lens.setAttribute('aria-hidden', 'true');
    const enlarged = document.createElement('img');
    enlarged.alt = '';
    enlarged.draggable = false;
    lens.append(enlarged);
    stage.append(lens);
    const hide = () => { lens.hidden = true; stage.classList.remove('is-magnifying'); };
    const scale = 2.5;
    on(stage, 'pointermove', event => {
      if (!pointer.matches || event.pointerType === 'touch' || event.target.closest('button') || !source.naturalWidth) return hide();
      const bounds = stage.getBoundingClientRect();
      const imageBounds = source.getBoundingClientRect();
      const ratio = Math.min(imageBounds.width / source.naturalWidth, imageBounds.height / source.naturalHeight);
      const width = source.naturalWidth * ratio;
      const height = source.naturalHeight * ratio;
      const position = getComputedStyle(source).objectPosition.split(' ').map(value => parseFloat(value) / 100);
      const left = imageBounds.left - bounds.left + (imageBounds.width - width) * (position[0] || 0);
      const top = imageBounds.top - bounds.top + (imageBounds.height - height) * (position[1] || 0);
      const x = event.clientX - bounds.left;
      const y = event.clientY - bounds.top;
      if (x < left || x > left + width || y < top || y > top + height) return hide();
      if (enlarged.src !== source.src) enlarged.src = source.src;
      lens.hidden = false;
      stage.classList.add('is-magnifying');
      const size = Math.min(260, bounds.width * 0.46);
      const lensHeight = size * 0.8;
      lens.style.width = `${size}px`;
      lens.style.height = `${lensHeight}px`;
      lens.style.left = `${Math.max(0, Math.min(x - size / 2, bounds.width - size))}px`;
      lens.style.top = `${Math.max(0, Math.min(y - lensHeight / 2, bounds.height - lensHeight))}px`;
      enlarged.style.width = `${width * scale}px`;
      enlarged.style.height = `${height * scale}px`;
      enlarged.style.left = `${size / 2 - (x - left) * scale}px`;
      enlarged.style.top = `${lensHeight / 2 - (y - top) * scale}px`;
    });
    on(stage, 'pointerleave', hide);
    on(stage, 'pointercancel', hide);
    on(source, 'load', hide);
    on(window, 'scroll', hide, {passive: true});
    on(window, 'resize', hide);
    on(window, 'blur', hide);
    on(pointer, 'change', hide);
    on(document, 'keydown', event => { if (event.key === 'Escape') hide(); });
    cleanup = () => { controller.abort(); lens.remove(); stage.classList.remove('is-magnifying'); };
  }
  init();
  document.addEventListener('shopify:section:load', init);
})();
